import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { StreamTypes } from 'store/player/actions.types';
import { RBChannel } from 'store/railsBuilder/reducer.types';
import { selectEntitlements } from 'store/user/selectors';

import isSubscribedToChannel from 'utils/isSubscribedToChannel';
import { isEmpty } from 'utils/object';

import { PlayerError } from 'screens/PlayerModal/types';

import { BitmovinPlayerSource } from 'components/Player/types.ts';

type Params = {
    videoSource: BitmovinPlayerSource;
    playerError: PlayerError;
    playbackType: StreamTypes | undefined;
    channel: RBChannel | undefined;
    onSetUnsubsribedChannelError(): void;
};

function useSubscribeToEntitlementsChange({
    videoSource,
    playbackType,
    playerError,
    channel,
    onSetUnsubsribedChannelError,
}: Params) {
    const entitlements = useSelector(selectEntitlements);

    useEffect(() => {
        if (
            videoSource &&
            isEmpty(playerError) &&
            playbackType !== StreamTypes.vod &&
            channel &&
            !isSubscribedToChannel(channel, entitlements)
        ) {
            onSetUnsubsribedChannelError();
        }
    }, [entitlements]);
}

export default useSubscribeToEntitlementsChange;
